var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveShareUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08687 6.26399C5.724 6.61598 5.72399 7.18666 6.08687 7.53865L10.6862 12L6.08661 16.4615C5.72373 16.8135 5.72373 17.3842 6.08661 17.7362C6.44948 18.0882 7.03782 18.0882 7.40069 17.7362L12.0002 13.2746L16.5995 17.7359C16.9624 18.0879 17.5507 18.0879 17.9136 17.7359C18.2765 17.3839 18.2765 16.8133 17.9136 16.4613L13.3143 12L17.9133 7.53889C18.2762 7.18691 18.2762 6.61622 17.9133 6.26424C17.5505 5.91225 16.9621 5.91225 16.5993 6.26423L12.0002 10.7253L7.40095 6.26399C7.03808 5.912 6.44974 5.912 6.08687 6.26399Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveShareUser);
export default __webpack_public_path__ + "static/media/remove_share_user.636cb66258d77e8b9be57c17e10a27fe.svg";
export { ForwardRef as ReactComponent };